<section class="error">
  <div class="error__inner">
      <h1>500</h1>
      <h2>{{'error.label.500' | translate}}</h2>
      <p>{{'error.label.500.desc' | translate}}</p>

      <button class="btn btn-primary" (click)="goBack()"> {{ 'generic.label.go.back' | translate}} </button>

  </div>
</section>
